import { colors } from "../../../common/styles";

export default (theme) => ({
    // Locations
    locRoot: {
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    },
    datesRoot: { textAlign: "center", padding: theme.spacing(3) },
    // Dates
    dateTitle: {
        padding: theme.spacing(2),
        fontSize: theme.spacing(3)
    },
    // Summary
    root: {
        width: "100%",
        padding: theme.spacing(1.5),
        borderTop: `1px solid ${colors.grey}`
    },
    inline: {
        display: "inline"
    },
    whiteSpace: {
        whiteSpace: "pre"
    },
    title: {
        fontWeight: "bold",
        padding: `0 ${theme.spacing(1)}`
    },
    field: {
        fontWeight: "bold",
        color: "#999"
    },
    summaryListItem: {
        paddingTop: 0,
        paddingBottom: 0
    },
    auditBtnWrapper: {
        position: "relative"
    },
    createAuditBtn: {
        width: "100%"
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    },
    // Container
    detailsRoot: {
        margin: theme.spacing(1),
        padding: theme.spacing(1)
    },
    sectionHeader: {
        margin: `${theme.spacing(1)} 0`
    },
    paperContainer: {
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        height: "100%"
    },
    paperContainerDisable: {
        opacity: "0.5",
        pointerEvents: "none"
    },
    paperActiveContainer: {
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: `0px 1px 1px 1px ${theme.palette.main}`
    },
    searchFilterContainer: {
        padding: theme.spacing(1)
    },

    // leave audit dialog
    leaveAuditDialogTitle: {
        margin: 0,
        padding: theme.spacing(2)
    },
    leaveAuditDialogCloseButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
    leaveAuditDialogContent: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(2)
    },
    leaveAuditDialogText: {
        marginBottom: theme.spacing(2)
    },
    leaveAuditDialogActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
        marginTop: theme.spacing(2)
    }

});
